export default "__VITE_ASSET__DMVpW353__"